import React from 'react';
const PipeTee4Icon = ({ width = 64, height = 64 }) => {
  const id = React.useId().replace(/:/g, '');
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 112.5 112.5">
      <defs>
        <linearGradient id={`${id}_1`} gradientUnits="userSpaceOnUse" x1="56.25" y1="56.25" x2="112.5" y2="56.25">
          <stop offset="0.01" stopColor="#646464" />
          <stop offset="0.18" stopColor="#949494" />
          <stop offset="0.5" stopColor="#DFDFDF" />
          <stop offset="1" stopColor="#656565" />
        </linearGradient>
        <linearGradient id={`${id}_2`} gradientUnits="userSpaceOnUse" x1="42.188" y1="84.375" x2="42.188" y2="28.1255">
          <stop offset="0.01" stopColor="#646464" />
          <stop offset="0.16" stopColor="#8F8F8F" />
          <stop offset="0.49" stopColor="#DFDFDF" />
          <stop offset="1" stopColor="#646464" />
        </linearGradient>
      </defs>
      <polygon fill={`url(#${id}_1)`} points="56.25,0 56.25,28.125 56.25,84.375 56.25,112.5 112.5,112.5 112.5,0" />
      <polygon fill={`url(#${id}_2)`} points="56.25,28.125 0,28.125 0,84.375 56.25,84.375 84.375,56.25" />
    </svg>
  );
};
export default PipeTee4Icon;
